import { Component } from "@angular/core"
import { EnvironmentUtilService } from "./_util/environment-util.service"

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
})
export class AppComponent {
    title: any = ""
    constructor(public _environmentUS: EnvironmentUtilService) {
        this.title = this._environmentUS.variable.domain_title
    }
}
